// Vendor Components
import {graphql} from 'react-apollo';

// Queries
import * as viewerQuery from './viewer.gql';

// Types
export enum Kind {
  Admin = 'ADMIN',
  Client = 'CLIENT',
  Professional = 'PROFESSIONAL'
}

export interface Viewer {
  id: string;
  kind: Kind;
  fullname: string | null;
}

export interface ViewerResult {
  viewer: Viewer | null;
}

export default graphql<ViewerResult>(viewerQuery, {
  options: {fetchPolicy: 'network-only'}
});



// WEBPACK FOOTER //
// ./src/ui/authenticated/components/with-viewer/with-viewer.tsx